import React, { useEffect, useState } from "react";
import { getIconByName, getName } from "../report-service/report-sample-service";
import MenuButton from "pages/report-constructor/items/menu-button/menu-button";
import { SelectDropdown } from "commons/input-controls";
import FontBase from "../font-base/font-base";
import FeedSettings from "pages/report-constructor/items/feed-settings/feed-settings";
import s from "./feeds.module.scss";

const Feeds = (props) => {

    const getList = (list) => {
        return list.map(k => {return {name: props.getValue(k), list: k}});
    }

    const getListNames = (list) => {
        return list.map(k => {return {name: props.getValue(k.name), list: k.list}});
    }

    const [docsElements, setDocsElements] = useState(props.documentElementsList.map(k => { return {title: props.getValue(k), type: k, list: k, icon: getIconByName(k)} } ));

    const getNameByList = (list) => {
        let f = props.includeTocList.findIndex(k => k.list === list);
        return f !== -1 ? props.includeTocList[f].name : ''
    }
 
    const [textRepresentation, setTextRepresentations] = useState(getList(props.textRepresentationList));
    const [groupingTypeList, setGroupingTypeList] = useState(props.groupingTypeList);
    const [includeTocList, setIncludeTocList] = useState(getListNames(props.includeTocList));
    const [parameters, setParameters] = useState(props.parameters && props.parameters ? props.parameters : null);
    const [isReadOnly, setIsReadOnly] = useState(props.isReadOnly);
    const [rerender, setRerender] = useState(false);

    useEffect(() => {
        setTextRepresentations(getList(props.textRepresentationList));
        setGroupingTypeList(getList(props.groupingTypeList));
        setIncludeTocList(getListNames(props.includeTocList));
        setParameters(props.parameters && props.parameters ? props.parameters : null);
        setIsReadOnly(props.isReadOnly);
        setDocsElements(props.documentElementsList.map(k => { return {title: props.getValue(k), type: k, list: k, icon: getIconByName(k)} } ))
        setRerender(!rerender);
    }, [props])

    const setSelected = (selected) => {
        let params = parameters;
        let selectedTypes = [...params.DOCUMENT_ELEMENTS];
        let finded = selectedTypes.indexOf(selected);
        if(finded !== -1){
            if(selected === "DOCUMENT_TEXT"){
                delete params.TEXT_REPRESENTATION;
            }
            selectedTypes.splice(finded, 1)
        }
        else{
            selectedTypes.push(selected);
        }
        let docElements = [...params.DOCUMENT_ELEMENTS];
        docElements = selectedTypes;
        params.DOCUMENT_ELEMENTS = docElements;
        props.updateComponent(props.index, params)
        setRerender(!rerender);
    }

    const updateFeedItems = (type, item) => {
        updateParameters(type, null, item.list)
    }

    const updateFeedSettings = (settings) => {
        let param = settings;
        setParameters(param)
        setRerender(!rerender);
    }

    const updateParameters = (type, parameter, value) => {
        let params = {...parameters};
        if(parameter){
            let fontParams = {...params[type]}
            fontParams[parameter] = value;
            params[type] = fontParams
        }
        else
            params[type] = value;
        if(value === ''){
            if(parameter)
                delete params[type][parameter];
            else
                delete params[type];
        }
        props.updateComponent(props.index, params);
        setRerender(!rerender)
    }

    const elements = docsElements.map((k, i) => 
                                            <MenuButton
                                            selectedLanguage={props.selectedLanguage}
                                                selected={parameters.DOCUMENT_ELEMENTS.indexOf(k.list) !== -1 ? true : false} 
                                                icon={k.icon} 
                                                title={k.title} 
                                                callback={setSelected} 
                                                type={k.list}
                                                isReadOnly={isReadOnly}
                                                key={i}
                                            />
                                        );

    const saveFeed = () => {
        let type = 'FEED';
        props.updateTemplateComponents(parameters, type)
    }

    const removeParameter = () => {
        props.removeParameter(props.index, 'FONT_PARAMETERS');
    }

    const addParameter = () => {
        props.addParameter(props.index, 'FONT_PARAMETERS');
    }
   
    return (
        <div className={s.Sample}>
            <div className={s.selectedElements}>{parameters && parameters.DOCUMENT_ELEMENTS ? props.getValue('SELECTED_ELEMENTS') + ': ' + parameters.DOCUMENT_ELEMENTS.length : ''}</div>
            <div className={s.SampleButtons}>{ elements }</div>
            <div className="formRow">
                <FeedSettings 
                            getValue={props.getValue}
                            feedSettings={props.feedSettings}
                            parameters={parameters}
                            updateFeedSettings={updateFeedSettings}
                            isReadOnly={isReadOnly}
                />
            </div>
            <div className={s.TableBlock}>
                 <FontBase 
                        readOnly={isReadOnly} 
                        getValue={props.getValue} 
                        fonts={props.fonts} colors={props.colors} 
                        parameters={parameters.FONT_PARAMETERS} 
                        updateParameters={updateParameters} 
                        type={'FONT_PARAMETERS'}
                        removeParameter={removeParameter} 
                        addParameter={addParameter}
                        />
            </div>
            {parameters && parameters.DOCUMENT_ELEMENTS && parameters.DOCUMENT_ELEMENTS.indexOf('DOCUMENT_TEXT') !== -1 ? <div className="formRow">
                <div className="labelText">{props.getValue('CONTENT_DISPLAY')}</div>
                <SelectDropdown height={250} showOnly={isReadOnly} selected={parameters.TEXT_REPRESENTATION ? props.getValue(parameters.TEXT_REPRESENTATION) : ""} items={textRepresentation} setSelected={updateFeedItems.bind(this, 'TEXT_REPRESENTATION')} indexKey={'TEXT_REPRESENTATION'}/>
            </div> : null}
            <div className="formRow">
                <div className="labelText">{props.getValue('GROUP_CONTENT')}</div>
                <SelectDropdown height={150} showOnly={isReadOnly} selected={parameters.GROUPING_TYPE ? props.getValue(parameters.GROUPING_TYPE) : ""} items={groupingTypeList} setSelected={updateFeedItems.bind(this, 'GROUPING_TYPE')}/>
            </div>
            <div className="formRow">
                <div className="labelText">{props.getValue('BRIEF_SUMMARY')}</div>
                <SelectDropdown height={150} showOnly={isReadOnly} selected={props.getValue(getNameByList(parameters.INCLUDE_TOC))} items={includeTocList} setSelected={updateFeedItems.bind(this, 'INCLUDE_TOC')}/>
            </div>
        </div>
    )
}

export default Feeds;